import { TimelineMax, Power1 } from 'gsap';

export default ({
    arrowDown,
    arrowUp,
    slideTop,
    slideBottom,
    map,
    halo,
    // stars,
    duration,
}) => {
    const timeline = new TimelineMax();

    timeline.fromTo(arrowDown, duration, {
        alpha: 1,
    }, {
        alpha: 0,
        ease: Power1.easeInOut,
    }, 0);

    timeline.fromTo(arrowUp, duration, {
        alpha: 0,
    }, {
        alpha: 1,
        ease: Power1.easeInOut,
    }, 0);

    timeline.fromTo(slideTop, duration, {
        yPercent: 0,
    }, {
        yPercent: -100,
        ease: Power1.easeInOut,
    }, 0);

    timeline.fromTo(slideBottom, duration, {
        yPercent: 100,
    }, {
        yPercent: 0,
        ease: Power1.easeInOut,
    }, 0);

    timeline.fromTo(map, duration, {
        alpha: 1,
    }, {
        alpha: 0,
        ease: Power1.easeInOut,
    }, 0);

    timeline.fromTo(halo, duration, {
        alpha: 0,
    }, {
        alpha: 1,
        ease: Power1.easeInOut,
    }, 0);

    // timeline.fromTo(stars, duration, {
    //     alpha: 1,
    // }, {
    //     alpha: 0,
    //     ease: Power1.easeInOut,
    // }, 0);

    return timeline;
};



// WEBPACK FOOTER //
// ./animations/slideContent.js